import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator, setPersistence, browserSessionPersistence, inMemoryPersistence } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FB_API_KEY,
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FB_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FB_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FB_APP_ID,
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, "us-central1");
export const storage = getStorage(app);

// Initialize Firebase App Check (prevents API abuse and bots)
// To enable: Get reCAPTCHA v3 site key from https://www.google.com/recaptcha/admin
// Then set VITE_RECAPTCHA_SITE_KEY in your .env file
if (import.meta.env.VITE_RECAPTCHA_SITE_KEY && !import.meta.env.DEV) {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(import.meta.env.VITE_RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });
    console.log('✅ Firebase App Check enabled');
  } catch (error) {
    console.warn('Failed to initialize App Check:', error);
  }
}
// Use session persistence so users stay logged in during browser session
setPersistence(auth, browserSessionPersistence).catch((error) => {
  if (import.meta.env.DEV) {
    console.warn('Failed to set session persistence:', error);
  }
  // Fallback to in-memory persistence for incognito mode
  return setPersistence(auth, inMemoryPersistence).catch(() => {
    if (import.meta.env.DEV) {
      console.warn('Failed to set any auth persistence');
    }
  });
});

if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === "true") {
  connectFirestoreEmulator(db, "localhost", 8080);
  connectAuthEmulator(auth, "http://localhost:9099");
  try { connectFunctionsEmulator(functions, "localhost", 5001); } catch {}
  if (import.meta.env.DEV) console.log("✅ Using Firebase Emulators");
}
